<div class="gp-signin">
  <section class="gp-signin-card">
    <ui-illustration class="gp-signin-art" name="waving-hand" [size]="72" />
    <h1 class="gp-signin-title">
      {{ purpose() === 'enroll' ? 'Set up two-factor authentication' : 'Two-factor authentication' }}
    </h1>
    <p class="gp-signin-sub">
      @if (mfaMethod() === 'passkey') {
        Use your registered passkey to finish signing in.
      } @else if (purpose() === 'enroll') {
        Scan the QR code with your authenticator app, then enter the 6-digit code.
      } @else {
        Enter the 6-digit code from your authenticator app.
      }
    </p>

    <!-- Error Alert (TOTP flow) -->
    @if (mfaMethod() === 'totp' && errorMessage()) {
      <mat-error class="error-banner" data-testid="mfa-error">
        <mat-icon>error</mat-icon>
        <span>{{ errorMessage() }}</span>
      </mat-error>
    }

    <!-- Enrollment step 1: QR code -->
    @if (mfaMethod() === 'totp' && needsEnrollment()) {
      <div class="enroll-pending" data-testid="mfa-enroll-pending">
        <mat-progress-spinner mode="indeterminate" diameter="36" />
        <span>Generating your authenticator setup…</span>
      </div>
    }

    @if (mfaMethod() === 'totp' && otpauthUri()) {
      <div class="otpauth-section" data-testid="mfa-otpauth">
        <app-authenticator-apps [otpauthUri]="otpauthUri()!" />
      </div>
    }

    <!-- Passkey branch (Phase 2, task 2.5): only when the login response
         carried hasPasskey. A TOTP-only contact never renders this. -->
    @if (mfaMethod() === 'passkey') {
      <div class="passkey-section" data-testid="mfa-passkey-section">
        @if (passkeyError()) {
          <mat-error class="error-banner" data-testid="mfa-passkey-error">
            <mat-icon>error</mat-icon>
            <span>{{ passkeyError() }}</span>
          </mat-error>
        }

        @if (remainingLabel(); as label) {
          <!-- R30: no countdown beside authenticator codes unless under a minute. -->
          <div class="countdown-row">
            <span class="countdown countdown-low" data-testid="mfa-countdown">
              Sign-in times out in {{ label }}
            </span>
          </div>
        }

        <button
          type="button"
          mat-flat-button
          color="primary"
          class="submit-button"
          [disabled]="passkeyBusy()"
          (click)="onUsePasskey()"
          data-testid="mfa-use-passkey-btn"
        >
          @if (passkeyBusy()) {
            <mat-progress-spinner mode="indeterminate" diameter="20" />
          }
          <span>Use passkey</span>
        </button>

        <button
          type="button"
          mat-button
          color="primary"
          class="fallback-link"
          [disabled]="passkeyBusy()"
          (click)="useTotpInstead()"
          data-testid="mfa-use-totp-link"
        >
          Use authenticator code instead
        </button>
      </div>
    }

    <!-- Code entry (both modes) — the TOTP flow, byte-for-byte unchanged -->
    @if (mfaMethod() === 'totp' && !needsEnrollment()) {
      <div class="mfa-form">
        <div class="code-boxes-header">
          <label class="code-boxes-label">Authentication code</label>
          <!-- R30: "Expires in m:ss" only when the sign-in is nearly out of time. -->
          @if (remainingLabel(); as label) {
            <span class="countdown countdown-low" data-testid="mfa-countdown">
              Sign-in times out in {{ label }}
            </span>
          }
        </div>
          <div class="code-boxes" (paste)="onPaste($event)" data-testid="mfa-code-input">
          @for (i of digitIndexes; track i) {
            <input
              #digitBox
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              maxlength="1"
              [value]="digits()[i]"
              (input)="onDigitInput(i, $any($event.target).value)"
              (keydown)="onDigitKeydown(i, $event)"
              [disabled]="isLoading()"
              [attr.data-testid]="'mfa-code-box-' + i"
            />
          }
        </div>

        @if (hasPasskey()) {
          <button
            type="button"
            mat-button
            color="primary"
            class="fallback-link"
            [disabled]="isLoading()"
            (click)="usePasskeyInstead()"
            data-testid="mfa-use-passkey-link"
          >
            Use passkey instead
          </button>
        }

        <button
          type="button"
          mat-flat-button
          color="primary"
          class="submit-button"
          [disabled]="!canSubmit()"
          (click)="onSubmit()"
          data-testid="mfa-submit-btn"
        >
          @if (isLoading()) {
            <mat-progress-spinner mode="indeterminate" diameter="20" />
          }
          <span>{{ isLoading() ? 'Verifying…' : 'Verify' }}</span>
        </button>
      </div>
    }
  </section>
</div>